import { memo } from 'react';
import type { BankingSdkConnector } from 'features/openBanking/types';
import Tabs from "ui/atoms/Tabs";
import {
    useResourceContext,
    ResourceDetail,
    type ResourceDetailProps
} from "ui/widgets/Resource";
import { EditBankingSDKResourceForm, ManageBankingSDKConnectorsRecipientsPivot } from './tabs';

const BankingSDKDetail = (props: ResourceDetailProps) => {
    const { onClose } = useResourceContext<BankingSdkConnector>();

    return (
        <ResourceDetail
            {...props}
            disableCloseOnBackdropClick
            onClose={onClose}
        >
            <Tabs
                model={[
                    {
                        label: 'Edit Banking SDK Resource',
                        component: (
                            <EditBankingSDKResourceForm />
                        )
                    },
                    {
                        label: 'Manage Open Banking Recipients',
                        component: (
                            <ManageBankingSDKConnectorsRecipientsPivot />
                        ),
                        sxProps: {
                            pt: 0
                        }
                    }
                ]}
                TabListContainerProps={{
                    borderBottom: 1,
                    borderColor: 'divider'
                }}
                TabListProps={{
                    'aria-label': 'banking sdk details',
                    variant: 'scrollable',
                    scrollButtons: 'auto'
                }}
            />
        </ResourceDetail>
    );
};

export default memo(BankingSDKDetail);
